import React from "react";

const StateCredit = () => {
  const schoolData = [
    {
      "Bank Name": "Alpine Credit Union",
      Address: "1510 N STATE ST, OREM, UT 84057",
      "CEO/President": "Paul Atkinson, President",
      "Contact No:": "801-225-0256",
    },
    {
      "Bank Name": "Beckstrand & Associates Emp. CU",
      Address: "6322 S 3000 E #160, SALT LAKE CITY, UT 84121",
      "CEO/President": "Julie Jackson, President",
      "Contact No:": "801-944-7722",
    },
    {
      "Bank Name": "Education First Credit Union",
      Address: "1250 COUNTRY HILL DR, OGDEN, UT 84403",
      "CEO/President": "Kent Greenfield, President",
      "Contact No:": "801-392-4877",
    },
    {
      "Bank Name": "Firefighters Credit Union",
      Address: "124 W 1400 S STE 101, SALT LAKE CITY, UT 84115-5227",
      "CEO/President": "Thomas R. Gourdin, President",
      "Contact No:": "801-487-3219",
    },
    {
      "Bank Name": "Freedom Credit Union",
      Address: "815 N FREEDOM BLVD, PROVO, UT 84604",
      "CEO/President": "Ken Payne, President",
      "Contact No:": "801-375-2120",
    },
    {
      "Bank Name": "Hi-Land Credit Union",
      Address: "5366 S EXECUTIVE PK DR, MURRAY, UT 84117",
      "CEO/President": "Misty Miller, President",
      "Contact No:": "801-261-8909",
    },
    {
      "Bank Name": "HollyFrontier Employees Cr. Union",
      Address: "876 W HERITAGE POINT LN, PO BOX 666, BOUNTIFUL, UT 84011",
      "CEO/President": "Meagan Nattress, President",
      "Contact No:": "801-298-1024",
    },
    {
      "Bank Name": "Kings Peak Credit Union",
      Address: "180 N 300 E, ROOSEVELT, UT 84066-2005",
      "CEO/President": "Ryan Reynolds, President",
      "Contact No:": "435-722-3795",
    },
    {
      "Bank Name": "Members First Credit Union",
      Address: "120 E 1000 S, PO BOX 657, BRIGHAM CITY, UT 84302-0657",
      "CEO/President": "Darryn Hodgson, President",
      "Contact No:": "435-723-5231",
    },
    {
      "Bank Name": "Millard County Credit Union",
      Address: "109 S 300 E, DELTA, UT 84624",
      "CEO/President": "Scott Lemmon, President",
      "Contact No:": "800-845-5824",
    },
    {
      "Bank Name": "National J.A.C.L. Credit Union",
      Address: "3776 S HIGHLAND DR, SALT LAKE CITY, UT 84106",
      "CEO/President": "Dean Hirabayashi, President",
      "Contact No:": "801-424-5225",
    },
    {
      "Bank Name": "Nebo Credit Union",
      Address: "730 E 300 S, SPRINGVILLE, UT 84663",
      "CEO/President": "Dale Phelps, President",
      "Contact No:": "801-491-3691",
    },
    {
      "Bank Name": "P & S Credit Union",
      Address: "2250 S REDWOOD RD STE 6, SALT LAKE CITY, UT 84119",
      "CEO/President": "Tammy Morgan, President",
      "Contact No:": "801-973-0575",
    },
    {
      "Bank Name": "Pacific Horizon Credit Union",
      Address: "96 E CENTER, PO BOX 166, SPRINGVILLE, UT 84663-0166",
      "CEO/President": "Mike Clayson, President",
      "Contact No:": "801-489-3605",
    },
    {
      "Bank Name": "Presto Lewiston Employees Cr. Union",
      Address: "1110 E 200 S, LEWISTON, UT 84320",
      "CEO/President": "Gaylene Stone, President",
      "Contact No:": "435-258-2431",
    },
    {
      "Bank Name": "Provo Police & Fire Department CU",
      Address: "250 W CTR ST STE 114, PO BOX 1402, PROVO, UT 84603",
      "CEO/President": "Sheldon Lindsay, President",
      "Contact No:": "801-377-5634",
    },
    {
      "Bank Name": "S E A Credit Union",
      Address: "275 E 800 N, PO BOX 355, RICHFIELD, UT 84701-0355",
      "CEO/President": "Brent Prisbrey, President",
      "Contact No:": "435-201-2085",
    },
    {
      "Bank Name": "San Juan Credit Union",
      Address: "792 S 200 W, BLANDING, UT 84511-0199",
      "CEO/President": "Leah Lyman, President",
      "Contact No:": "435-678-2124",
    },
    {
      "Bank Name": "South Sanpete Credit Union",
      Address: "39 S MAIN, MANTI, UT 84642",
      "CEO/President": "Jake Hill, President",
      "Contact No:": "435-835-2261",
    },
    {
      "Bank Name": "Uintah Credit Union",
      Address: "783 W HWY 40, PO BOX 805, VERNAL, UT 84078-0805",
      "CEO/President": "Dan Olsen, President",
      "Contact No:": "435-789-8353",
    },
    {
      "Bank Name": "Utah Heritage Credit Union",
      Address: "84 W MAIN, PO BOX 50, MORONI, UT 84646",
      "CEO/President": "Tami Olsen, President",
      "Contact No:": "435-436-8288",
    },
    {
      "Bank Name": "Utah Power Credit Union",
      Address: "957 E 6600 S, MURRAY, UT 84121",
      "CEO/President": "Ryan Pollick, President",
      "Contact No:": "801-708-8900",
    },
  ];

  const getGoogleMapsUrl = (address) =>
    `https://www.google.com/maps/search/?api=1&query=${encodeURIComponent(
      address
    )}`;

  return (
    <div className="flex items-center justify-center my-12">
      <div className="bg-gray-300 z-10 rounded-xl shadow-[0_4px_12px_0_rgba(1,76,178,0.3)] overflow-hidden w-[95%]">
        <div className="overflow-x-auto max-h-[800px]">
          <table className="table-auto border-collapse border bg-white border-gray-300 w-full">
            <thead className="sticky top-0 z-10">
              <tr>
                <th className="border border-gray-300 bg-gray-300 px-4 py-2 text-left">
                  Bank Name
                </th>
                <th className="border border-gray-300 bg-gray-300 px-4 py-2 text-left">
                  Address
                </th>
                <th className="border border-gray-300 bg-gray-300 px-4 py-2 text-left">
                  Contact No
                </th>
              </tr>
            </thead>
            <tbody>
              {schoolData.map((school, index) => (
                <tr
                  key={`${school["Bank Name"]}-${index}`}
                  className="odd:bg-white even:bg-gray-100 hover:bg-gray-200"
                >
                  <td className="border border-gray-300 px-4 py-2 text-left text-blue-900">
                    {school["Bank Name"]}
                  </td>
                  <td className="border border-gray-300 px-4 py-2 text-left text-blue-900">
                    <a
                      href={getGoogleMapsUrl(school.Address)}
                      target="_blank"
                      rel="noopener noreferrer"
                      className="no-underline hover:no-underline text-blue-900"
                    >
                      {school.Address}
                    </a>
                  </td>
                  <td className="border border-gray-300 px-4 py-2 text-left text-blue-900">
                    {school["Contact No:"]}
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>
    </div>
  );
};

export default StateCredit;
